import { fetcher } from 'services';

const usePopupInfo = () => {
  /**
   * 노출 중인 온보딩 팝업 정보
   */
  const getOnboardingPopupInfo = (isBypassOnboardingYn?: boolean) => {
    if (isBypassOnboardingYn) {
      return fetcher.popupInfo.getOnboardingInfo({
        isBypassOnboardingYn: isBypassOnboardingYn,
      });
    }
    return fetcher.popupInfo.getOnboardingInfo();
  };

  /**
   * 온보딩 팝업 열람 완료
   */
  const readOnboardingPopupInfo = () => {
    return fetcher.popupInfo.readOnboarding();
  };

  /**
   * 노출 중인 이벤트 팝업 정보 조회
   */
  const getEPEventPromotionPopupInfo = () => {
    return fetcher.popupInfo.getEPEventPromotionInfo();
  }

  /**
   * 이벤트 팝업 열람 처리
   * @param params 열람 요청 정보
   */
  const readEPEventPromotionPopup = (params: PopupReadReqDto) => {
    return fetcher.popupInfo.readEPEventPromotion(params);
  }

  /**
   * 노출 중인 일반 팝업 정보 조회
   */
  const getNormalPopupInfo = () => {
    return fetcher.popupInfo.getNormalPopupInfo();
  }

  /**
   * 일반 팝업 열람 처리
   * @param params 열람 요청 정보
   */
  const readNormalPopup = (params: PopupReadReqDto) => {
    return fetcher.popupInfo.readNormalPopup(params);
  }

  return {
    getOnboardingPopupInfo,
    readOnboardingPopupInfo,
    getEPEventPromotionPopupInfo,
    readEPEventPromotionPopup,
    getNormalPopupInfo,
    readNormalPopup
  };
};

export default usePopupInfo;
